import { apiSlice } from 'src/services/apiSlice'
import formatApp from '../../util/formatApp'
import { MOCK_SCOPES } from '../../mocks/mockScopes'

const transformAppsResponse = (response) => ({
  myApps: response.collection.map((app) => formatApp(app)),
  newAppsExperienceEnabled: Boolean(response.new_apps_experience_enabled)
})

const onQueryStartedUnauthError = async (args, { queryFulfilled }) => {
  try {
    await queryFulfilled
  } catch (error) {
    if (error.error.originalStatus === 401) {
      window.location.assign('/')
    }
  }
}

export const appsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getApps: builder.query({
      query: () => ({ url: `${process.env.GATSBY_BACKEND_URL}/api/oauth_apps` }),
      transformResponse: transformAppsResponse,
      providesTags: (result, error, arg) =>
        (result
          // eslint-disable-next-line
          ? [...result.myApps.map(({ clientId }) => ({ type: 'App', id: clientId })), 'App']
          : ['App'])
    }),
    getScopes: builder.query({
      async queryFn(_arg, _queryApi, _extraOptions, baseQuery) {
        if (process.env.NODE_ENV === 'test') {
          return { data: MOCK_SCOPES }
        }
        const result = await baseQuery({ url: `${process.env.GATSBY_BACKEND_URL}/api/scopes` })
        if (result.error) return { error: result.error }
        // Backend returns the new structure: [{ key, heading, scopes }, ...]
        return { data: result.data.collection }
      }
    }),
    createApp: builder.mutation({
      query: (body) => (
        { url: `${process.env.GATSBY_BACKEND_URL}/api/oauth_apps`, method: 'POST', body: formatApp(body) }),
      invalidatesTags: (result, error, arg) => [{ type: 'App', id: arg.clientId }],
      onQueryStarted: onQueryStartedUnauthError
    }),
    updateApp: builder.mutation({
      query: (body) => ({ url: `${process.env.GATSBY_BACKEND_URL}/api/oauth_apps/${body.clientId}`, method: 'PATCH', body: formatApp(body) }),
      invalidatesTags: (result, error, arg) => [{ type: 'App', id: arg.clientId }],
      onQueryStarted: onQueryStartedUnauthError
    }),
    deleteAppById: builder.mutation({
      query(id) {
        return {
          url: `${process.env.GATSBY_BACKEND_URL}/api/oauth_apps/${id}`,
          method: 'DELETE'
        }
      },
      invalidatesTags: (result, error, arg) => [{ type: 'App', id: arg.id }],
      onQueryStarted: onQueryStartedUnauthError
    })
  })
})

export const {
  useGetAppsQuery,
  useGetScopesQuery,
  useCreateAppMutation,
  useUpdateAppMutation,
  useDeleteAppByIdMutation
} = appsApiSlice
